// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/pricing.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.PriceHistoryEntry
 */
export const PriceHistoryEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceHistoryEntry",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vat_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "change_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "previous_value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "change_reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "changed_by", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "source_ref", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "changed_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceHistoryRequest
 */
export const GetPriceHistoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceHistoryRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "from_date", kind: "message", T: Timestamp, opt: true },
    { no: 5, name: "to_date", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceHistoryResponse
 */
export const GetPriceHistoryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceHistoryResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: PriceHistoryEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceAtDateRequest
 */
export const GetPriceAtDateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceAtDateRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "date", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceAtDateResponse
 */
export const GetPriceAtDateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceAtDateResponse",
  () => [
    { no: 1, name: "value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "found", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.POPriceRecord
 */
export const POPriceRecord = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.POPriceRecord",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "vendor_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "po_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "catalog_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "po_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "recorded_at", kind: "message", T: Timestamp },
    { no: 15, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.RecordPOPricesRequest
 */
export const RecordPOPricesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecordPOPricesRequest",
  () => [
    { no: 1, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lines", kind: "message", T: POPriceInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.POPriceInput
 */
export const POPriceInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.POPriceInput",
  () => [
    { no: 1, name: "line_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "vendor_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "po_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "po_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RecordPOPricesResponse
 */
export const RecordPOPricesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecordPOPricesResponse",
  () => [
    { no: 1, name: "recorded", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductPOHistoryRequest
 */
export const GetProductPOHistoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductPOHistoryRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vendor_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductPOHistoryResponse
 */
export const GetProductPOHistoryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductPOHistoryResponse",
  () => [
    { no: 1, name: "records", kind: "message", T: POPriceRecord, repeated: true },
    { no: 2, name: "avg_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "min_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "max_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "price_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 6, name: "record_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CompetitorPrice
 */
export const CompetitorPrice = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompetitorPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "competitor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "competitor_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "competitor_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "original_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "in_stock", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 12, name: "observed_at", kind: "message", T: Timestamp },
    { no: 13, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.CompetitorPriceSummary
 */
export const CompetitorPriceSummary = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompetitorPriceSummary",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "min_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "max_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "avg_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "median_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "competitor_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "our_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "our_price_rank", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "price_index", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "prices", kind: "message", T: CompetitorPrice, repeated: true },
    { no: 20, name: "calculated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Competitor price operations (competitors are parties with role='competitor')
 *
 * @generated from message omnios.v1.AddCompetitorPriceRequest
 */
export const AddCompetitorPriceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddCompetitorPriceRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "competitor_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "competitor_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "original_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "in_stock", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.AddCompetitorPriceResponse
 */
export const AddCompetitorPriceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddCompetitorPriceResponse",
  () => [
    { no: 1, name: "price", kind: "message", T: CompetitorPrice },
  ],
);

/**
 * @generated from message omnios.v1.GetProductCompetitorPricesRequest
 */
export const GetProductCompetitorPricesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductCompetitorPricesRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductCompetitorPricesResponse
 */
export const GetProductCompetitorPricesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductCompetitorPricesResponse",
  () => [
    { no: 1, name: "summary", kind: "message", T: CompetitorPriceSummary },
  ],
);

/**
 * @generated from message omnios.v1.ImportCompetitorFeedRequest
 */
export const ImportCompetitorFeedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportCompetitorFeedRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ImportCompetitorFeedResponse
 */
export const ImportCompetitorFeedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportCompetitorFeedResponse",
  () => [
    { no: 1, name: "prices_imported", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "products_matched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.RefreshCompetitorSummariesRequest
 */
export const RefreshCompetitorSummariesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RefreshCompetitorSummariesRequest",
  () => [
    { no: 1, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RefreshCompetitorSummariesResponse
 */
export const RefreshCompetitorSummariesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RefreshCompetitorSummariesResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.Discount
 */
export const Discount = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Discount",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "discount_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "fixed_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "override_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "is_stackable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "stacking_group", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "usage_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "usage_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "per_customer_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "targets", kind: "message", T: DiscountTarget, repeated: true },
    { no: 21, name: "conditions", kind: "message", T: DiscountCondition, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiscountTarget
 */
export const DiscountTarget = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiscountTarget",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "target_value", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "include", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.DiscountCondition
 */
export const DiscountCondition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiscountCondition",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "condition_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parameters", kind: "message", T: Struct },
  ],
);

/**
 * Discount CRUD
 *
 * @generated from message omnios.v1.CreateDiscountRequest
 */
export const CreateDiscountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateDiscountRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "discount_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "fixed_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "override_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 11, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "is_stackable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "stacking_group", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "usage_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 16, name: "per_customer_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "targets", kind: "message", T: DiscountTargetInput, repeated: true },
    { no: 21, name: "conditions", kind: "message", T: DiscountConditionInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DiscountTargetInput
 */
export const DiscountTargetInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiscountTargetInput",
  () => [
    { no: 1, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "target_value", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "include", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.DiscountConditionInput
 */
export const DiscountConditionInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiscountConditionInput",
  () => [
    { no: 1, name: "condition_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parameters", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateDiscountRequest
 */
export const UpdateDiscountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateDiscountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "fixed_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "override_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 11, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "targets", kind: "message", T: DiscountTargetInput, repeated: true },
    { no: 21, name: "conditions", kind: "message", T: DiscountConditionInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteDiscountRequest
 */
export const DeleteDiscountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteDiscountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetDiscountRequest
 */
export const GetDiscountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDiscountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDiscountsRequest
 */
export const ListDiscountsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDiscountsRequest",
  () => [
    { no: 1, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "target_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "target_category_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListDiscountsResponse
 */
export const ListDiscountsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDiscountsResponse",
  () => [
    { no: 1, name: "discounts", kind: "message", T: Discount, repeated: true },
  ],
);

/**
 * Get applicable discounts for a product
 *
 * @generated from message omnios.v1.GetProductDiscountsRequest
 */
export const GetProductDiscountsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductDiscountsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "order_total_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.GetProductDiscountsResponse
 */
export const GetProductDiscountsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductDiscountsResponse",
  () => [
    { no: 1, name: "discounts", kind: "message", T: ApplicableDiscount, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ApplicableDiscount
 */
export const ApplicableDiscount = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApplicableDiscount",
  () => [
    { no: 1, name: "discount", kind: "message", T: Discount },
    { no: 2, name: "discount_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "effective_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.Promocode
 */
export const Promocode = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Promocode",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "discount_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "inline_discount_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "inline_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 9, name: "inline_fixed_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "inline_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "usage_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "usage_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "per_customer_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "min_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Promocode CRUD
 *
 * @generated from message omnios.v1.CreatePromocodeRequest
 */
export const CreatePromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePromocodeRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "discount_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "inline_discount_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "inline_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "inline_fixed_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "inline_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 11, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "usage_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "per_customer_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "is_public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "min_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "assigned_customer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePromocodeRequest
 */
export const UpdatePromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePromocodeRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 11, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "end_date", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "usage_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "per_customer_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "min_order_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "min_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePromocodeRequest
 */
export const DeletePromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePromocodeRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPromocodeRequest
 */
export const GetPromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPromocodeRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPromocodesRequest
 */
export const ListPromocodesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPromocodesRequest",
  () => [
    { no: 1, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListPromocodesResponse
 */
export const ListPromocodesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPromocodesResponse",
  () => [
    { no: 1, name: "promocodes", kind: "message", T: Promocode, repeated: true },
  ],
);

/**
 * Assign promocode to customers
 *
 * @generated from message omnios.v1.AssignPromocodeRequest
 */
export const AssignPromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssignPromocodeRequest",
  () => [
    { no: 1, name: "promocode_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AssignPromocodeResponse
 */
export const AssignPromocodeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssignPromocodeResponse",
  () => [
    { no: 1, name: "assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Validate promocode
 *
 * @generated from message omnios.v1.ValidatePromocodeRequest
 */
export const ValidatePromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ValidatePromocodeRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "order_total_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lines", kind: "message", T: ValidatePromocodeLineInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ValidatePromocodeLineInput
 */
export const ValidatePromocodeLineInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ValidatePromocodeLineInput",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.ValidatePromocodeResponse
 */
export const ValidatePromocodeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ValidatePromocodeResponse",
  () => [
    { no: 1, name: "valid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "error_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "discount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "promocode", kind: "message", T: Promocode, opt: true },
  ],
);

/**
 * Apply promocode (record usage)
 *
 * @generated from message omnios.v1.ApplyPromocodeRequest
 */
export const ApplyPromocodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApplyPromocodeRequest",
  () => [
    { no: 1, name: "promocode_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "discount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ApplyPromocodeResponse
 */
export const ApplyPromocodeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApplyPromocodeResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "new_usage_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PriceSuggestion
 */
export const PriceSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceSuggestion",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "suggestion_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "current_po_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "previous_po_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "our_catalog_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "competitor_avg_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "competitor_min_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "price_change_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 12, name: "margin_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 13, name: "market_position", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "suggested_action", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "suggested_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 17, name: "reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 18, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetProductPriceSuggestionsRequest
 */
export const GetProductPriceSuggestionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductPriceSuggestionsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductPriceSuggestionsResponse
 */
export const GetProductPriceSuggestionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductPriceSuggestionsResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: PriceSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GeneratePriceSuggestionsRequest
 */
export const GeneratePriceSuggestionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GeneratePriceSuggestionsRequest",
  () => [
    { no: 1, name: "lines", kind: "message", T: GeneratePriceSuggestionLineInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GeneratePriceSuggestionLineInput
 */
export const GeneratePriceSuggestionLineInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GeneratePriceSuggestionLineInput",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "po_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.GeneratePriceSuggestionsResponse
 */
export const GeneratePriceSuggestionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GeneratePriceSuggestionsResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: PriceSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CalculatePriceRequest
 */
export const CalculatePriceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculatePriceRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "order_total_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "promocode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "include_competitor_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "include_margin_info", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculatePriceResponse
 */
export const CalculatePriceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculatePriceResponse",
  () => [
    { no: 1, name: "base_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "final_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "discounts_applied", kind: "message", T: AppliedDiscountInfo, repeated: true },
    { no: 11, name: "promocode_discount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "customer_markup_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 20, name: "competitor_comparison", kind: "message", T: CompetitorComparison, opt: true },
    { no: 21, name: "margin_info", kind: "message", T: MarginInfo, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.AppliedDiscountInfo
 */
export const AppliedDiscountInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AppliedDiscountInfo",
  () => [
    { no: 1, name: "discount_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "discount_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.CompetitorComparison
 */
export const CompetitorComparison = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompetitorComparison",
  () => [
    { no: 1, name: "our_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "market_avg_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "market_min_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "price_index", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "rank", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.MarginInfo
 */
export const MarginInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MarginInfo",
  () => [
    { no: 1, name: "cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "margin_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "margin_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * Bulk price calculation
 *
 * @generated from message omnios.v1.BulkCalculatePricesRequest
 */
export const BulkCalculatePricesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkCalculatePricesRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: CalculatePriceRequest, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BulkCalculatePricesResponse
 */
export const BulkCalculatePricesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkCalculatePricesResponse",
  () => [
    { no: 1, name: "responses", kind: "message", T: CalculatePriceResponse, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceAnalyticsRequest
 */
export const GetPriceAnalyticsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceAnalyticsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PriceAnalyticsPoint
 */
export const PriceAnalyticsPoint = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceAnalyticsPoint",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "our_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "competitor_avg_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "competitor_min_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "po_cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "margin_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "competitor_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceAnalyticsResponse
 */
export const GetPriceAnalyticsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceAnalyticsResponse",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_points", kind: "message", T: PriceAnalyticsPoint, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.PriceList
 */
export const PriceList = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceList",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "effective_from", kind: "message", T: Timestamp },
    { no: 6, name: "effective_until", kind: "message", T: Timestamp },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "customer_segment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "rules", kind: "message", T: PriceListRule, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PriceListRule
 */
export const PriceListRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceListRule",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "rule_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "discount_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "min_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "tiers", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.CreatePriceListRequest
 */
export const CreatePriceListRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePriceListRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "customer_segment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePriceListRequest
 */
export const UpdatePriceListRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePriceListRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "effective_from", kind: "message", T: Timestamp },
    { no: 6, name: "effective_until", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DeletePriceListRequest
 */
export const DeletePriceListRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePriceListRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPriceListRequest
 */
export const GetPriceListRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPriceListRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPriceListsRequest
 */
export const ListPriceListsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPriceListsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPriceListsResponse
 */
export const ListPriceListsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPriceListsResponse",
  () => [
    { no: 1, name: "price_lists", kind: "message", T: PriceList, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.AddPriceListRuleRequest
 */
export const AddPriceListRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddPriceListRuleRequest",
  () => [
    { no: 1, name: "price_list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "rule_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "discount_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "min_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "tiers", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.RemovePriceListRuleRequest
 */
export const RemovePriceListRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemovePriceListRuleRequest",
  () => [
    { no: 1, name: "price_list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

